import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
  name: 'addButton'
})
export default class AddButton extends Vue {
}
